export const defaultGyriGachaLoadingVideo =
  'https://static.gala.games/gyri-exchanges/defaultanimation.mp4';
